import { ChangeDetectorRef, Component, EventEmitter, Input, Output, Renderer2 } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { SubscriptionSliderComponent } from '../subscription-slider/subscription-slider.component';
declare var hbspt: any
@Component({
  selector: 'app-book-demo-popup',
  templateUrl: './book-demo-popup.component.html',
  styleUrls: ['./book-demo-popup.component.scss']
})


export class BookDemoPopupComponent {
  @Input() formType!: string

  @Output() closed = new EventEmitter<void>();
  isDemoForm:boolean = false;
  isAboutForm:boolean = false;
  env = environment;
  constructor(private renderer: Renderer2, private cd : ChangeDetectorRef) {}

  ngAfterContentInit() {
    this.loadHsFormsScript(() => {
      hbspt.forms.create({
        portalId: "4424590",
        formId: "70944c12-aad5-4f96-9cde-2c3bd2da8656",
        region: "na1",
        target: '#hubspot-form',
        onFormReady: function($form) {
          $form.find('input[type="submit"]').val('Request a Demo');
        }
      });
    });
  }

  private loadHsFormsScript(callback: () => void) {
    if (typeof hbspt !== 'undefined') {
      callback();
      return;
    }
    const existing = document.getElementById('hs-forms-script');
    if (existing) {
      existing.addEventListener('load', callback);
      return;
    }
    const script = document.createElement('script');
    script.id = 'hs-forms-script';
    script.charset = 'utf-8';
    script.type = 'text/javascript';
    script.src = '//js.hsforms.net/forms/embed/v2.js';
    script.onload = callback;
    document.head.appendChild(script);
  }

   ngAfterViewInit() {
    console.log(this.formType);
    if(this.formType == 'demoFourSight'){
      this.isDemoForm = true;
    }
    if(this.formType == 'aboutFourSight'){
      this.isAboutForm = true;
    }

     this.cd.detectChanges();
   }

  closePopup() {  
    this.closed.emit();
  }
}
